<app-about-banner></app-about-banner>
<!-- <app-home-apps></app-home-apps> -->
<app-about-content></app-about-content>
<app-sat></app-sat>
<router-outlet></router-outlet>